import { render } from "./RefreshTokenModal.vue?vue&type=template&id=412ef6a5"
import script from "./RefreshTokenModal.vue?vue&type=script&lang=js"
export * from "./RefreshTokenModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ricardo/Sites/customizer/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__